import * as React from "react";
import PropTypes from "prop-types";
import Chip from "@mui/material/Chip";

export default function StatusChip({ status }) {
  const isPublished = status === "published";
  return (
    <Chip
      label={isPublished ? "visible" : "not visible"}
      color={isPublished ? "success" : "warning"}
      size="small"
      variant="outlined"
    />
  );
}

StatusChip.propTypes = {
  status: PropTypes.string,
};
